import "../css/users.css";

import React from "react";
import Breadcrumb from "../components/breadcrumb";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import apiUrl from "../globals";
import "../css/reports.css"; 

const GamStatus = () => {  

    let breadcrumbItens = [
        {
            text: "Home",
            route: "/"
        },
        {
            text: "GAM Status",
            route: "#"
        }
    ];

    return (
        <div className="container">
            <div className="defaultContainer">               
                <div className="row">
                    <div className="col-12">
                        <h1 className="h1">GAM Status</h1>
                        <Breadcrumb links={breadcrumbItens} />
                    </div>
                </div>

                <br />

                {/* Boxes de status da SDK PHP – ocultos (não usados com Node) */}
                {/* <div className="row">
                    <div className="col-3">...</div>
                    ...
                </div>
                <br /> */}

                <div className="row">
                    <div className="col-12">
                        <h2 className="h4">Limpeza de utm_content</h2>
                    </div>
                </div>

                <br />

                <div className="row">
                    <div className="col-3">
                        <div className="card mb-3 reportCard">
                            <div className="card-header"><span className="material-symbols-outlined">monitoring</span>&nbsp;<label>GAM Noticia Oficial – Limpeza</label></div>
                            <div className="card-body">
                                <h5 className="card-title">GAM Noticia Oficial</h5>
                                <a href={`${apiUrl}/gam/logs/cleanup-usage?slug=no`} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary text-uppercase">Ver logs de limpeza</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="card mb-3 reportCard">
                            <div className="card-header"><span className="material-symbols-outlined">monitoring</span>&nbsp;<label>GAM Solicite Fácil – Limpeza</label></div>
                            <div className="card-body">
                                <h5 className="card-title">GAM Solicite Fácil</h5>
                                <a href={`${apiUrl}/gam/logs/cleanup-usage?slug=sf`} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary text-uppercase">Ver logs de limpeza</a>
                            </div>
                        </div>
                    </div>    
                    <div className="col-3">
                        <div className="card mb-3 reportCard">
                            <div className="card-header"><span className="material-symbols-outlined">monitoring</span>&nbsp;<label>GAM Portal Finança – Limpeza</label></div>
                            <div className="card-body">
                                <h5 className="card-title">GAM Portal Finança</h5>
                                <a href={`${apiUrl}/gam/logs/cleanup-usage?slug=pf`} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary text-uppercase">Ver logs de limpeza</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="card mb-3 reportCard">
                            <div className="card-header"><span className="material-symbols-outlined">monitoring</span>&nbsp;<label>GAM WTUPB – Limpeza</label></div>
                            <div className="card-body">
                                <h5 className="card-title">GAM WTUPB</h5>
                                <a href={`${apiUrl}/gam/logs/cleanup-usage?slug=wptupb`} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary text-uppercase">Ver logs de limpeza</a>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <HelmetProvider>
                <Helmet>
                    {/* <script src="./js/datatables/gam.js" type="text/javascript"></script> */}
                </Helmet>
            </HelmetProvider>  
        </div>
    );
}

export default GamStatus;

